
























































































































































































































import Vue from 'vue'
import { getAndSetHostIdFromLocalStorage } from '@/utils'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { mapState } from 'vuex'
import { deleteAccount } from '@/api/auth'
import { IAuthRequest } from '@/interfaces/auth'

export default Vue.extend({
  name: 'UserInfo',
  metaInfo (): MetaInfo {
    return {
      title: '帳號資訊',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  data () {
    return {
      fbName: '' as string,
      modalShow: 0
    }
  },
  computed: {
    ...mapState(['showNuCoin']),
    platform (): string {
      return this.$store.getters['webview/platform']
    },
    account (): string {
      let acc = this.$store.state.account || '' as string
      if (this.$store.getters.isWebViewMode) {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('account')) {
          acc = urlParams.get('account') as string
        }
      }
      if (acc.length <= 7) { return acc }
      const encryptedAcc = acc.substring(0, 4) + '*'.repeat(acc.length - 7) + acc.substring(acc.length - 3)
      return encryptedAcc.length === acc.length ? encryptedAcc : acc
    },
    accountText (): string {
      if (this.$store.getters.isWebViewMode) {
        return this.$store.getters.isFacebookUser ? 'FB帳戶 ' + this.fbName : this.account
      } else {
        return this.$store.getters.isFacebookUser ? `FB帳戶 ${this.$store.state.nickname}` : this.account
      }
    },
    nickname (): string {
      return this.$store.getters.isFacebookUser ? `Facebook ${this.$store.state.nickname}` : ''
    },
    appVersion (): string {
      return process.env.VUE_APP_VERSION
    },
    userAgent (): string {
      return window.navigator.userAgent
    },
    expireTimeText (): string {
      return this.$store.getters.nuCoinExpireTime.split(' ')[0]
    }
  },
  created () {
    if (this.$store.getters.isWebViewMode) {
      postAppMessage(MessageHandlers.UPDATE_HEADER, { type: 6, title: '帳號資訊' })
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('account')) {
        this.$store.commit('SET_USER_INFO', {
          token: urlParams.get('token') as string,
          account: urlParams.get('account'),
          id: urlParams.get('type') === '1' ? urlParams.get('account') : ''
        })
        this.fbName = (urlParams.get('type') === '1' ? urlParams.get('fb_name') : '') as string
        localStorage.setItem('userToken', urlParams.get('token') as string)
        this.$store.commit('INITIALIZE_TOKEN')
      }
      this.$store.dispatch('REFRESH_TOKEN')
    }
  },
  methods: {
    getHostId () {
      return getAndSetHostIdFromLocalStorage()
    },
    onModifyPasswordClicked () {
      // TODO: ModifyPassword
      console.log('Modify Password')
      if (this.$store.getters.isWebViewMode) {
        postAppMessage(MessageHandlers.NAVIGATE_TO_MODIFY_PASSWORD, true)
      }
    },
    showModal () {
      this.modalShow = 1
    },
    async deleteConfirm () {
      this.modalShow = 2
      this.clearUserInfoInLocalStorage()

      // notify customer service
      const requestBody: IAuthRequest = {
        token: this.$store.getters.token
      }

      await deleteAccount(requestBody)

      // notify App
      postAppMessage(MessageHandlers.DELETE_ACCOUNT, true)
    },
    deleteDone () {
      this.modalShow = 0
      postAppMessage(MessageHandlers.NAVIGATE_TO_SETTING, true)
    },
    clearUserInfoInLocalStorage () {
      localStorage.setItem('userName', '')
      localStorage.setItem('userPhone', '')
      localStorage.setItem('userEmail', '')
      localStorage.setItem('receiverName', '')
      localStorage.setItem('receiverPhone', '')
      localStorage.setItem('receiverNation', '0')
      localStorage.setItem('receiverCounty', '0')
      localStorage.setItem('receiverDistrict', '0')
      localStorage.setItem('receiverStreet', '')
      localStorage.setItem('receiverGlobal2', '')
      localStorage.setItem('receiptNum', '')
      localStorage.setItem('paymentType', '0')
      localStorage.setItem('eco/loadedFromApp', 'true')
      localStorage.setItem('eco/checkout', '')
    }
  }
})
